import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import DashboardLayout from '../../components/layout/DashboardLayout';
import PageHeader from '../../components/common/PageHeader';
import { getOffer, saveOffer, acceptOffer } from '../../services/messageService';
import { useI18n } from '../../i18n/I18nContext';

const OfferDetail = () => {
  const { t } = useI18n();
  const { id } = useParams();
  const navigate = useNavigate();
  const [offer, setOffer] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const data = await getOffer(id);
        setOffer(data);
        setError(null);
      } catch (e) {
        setError(t('offers.errors.notFound'));
      } finally {
        setLoading(false);
      }
    })();
  }, [id, t]);

  return (
    <DashboardLayout>
      <div className="container-fluid">
        <PageHeader title={t('offers.detail.title')} subtitle={t('offers.detail.subtitle', { id })} />
        {loading && <div className="text-muted">{t('common.loading')}</div>}
        {!loading && error && <div className="alert alert-danger">{error}</div>}
        {!loading && !error && offer && (
          <div className="card border-0 shadow-sm" style={{ borderRadius: '0.9375rem' }}>
            <div className="card-body">
              <div className="mb-3">
                <div className="small text-muted">{t('common.mission')}</div>
                <div className="fs-5 fw-semibold">{offer.missionSummary}</div>
              </div>
              <div className="mb-3">
                <div className="small text-muted">{t('offers.detail.fromExpediteur')}</div>
                <div className="fw-semibold">{offer.expediteurId}</div>
              </div>
              <div className="d-flex gap-2">
                <button className="btn btn-outline-secondary" onClick={async () => { await saveOffer(offer.id); navigate('/client'); }}>{t('common.save')}</button>
                <button className="btn btn-primary" onClick={async () => { await acceptOffer(offer.id); navigate('/missions'); }}>{t('clientOffers.actions.addToMissions')}</button>
              </div>
            </div>
          </div>
        )}
      </div>
    </DashboardLayout>
  );
};

export default OfferDetail;
